import { getBaseApi } from "../api";

const api = getBaseApi();

export const uploadFile = async (
  file: File,
  name?: string,
  owner?: { id: string; resourceType: string }
) => {
  const formData = new FormData();
  formData.append("file", file);
  if (name) {
    formData.append("name", name);
  }
  if (owner) {
    formData.append("owner", JSON.stringify(owner));
  }
  const response = await api.post("/files/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data?.data;
};
